// extracted by mini-css-extract-plugin
module.exports = {"grey":"PickupCard_grey__2Gj5Q","green":"PickupCard_green__2p7hZ","container":"PickupCard_container__2lOmd"};